var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ib-list-view-placeholder-card-wrapper",class:{'disabled': _vm.disabled}},[_c('div',{staticClass:"inner",class:_vm.variant})])
}
var staticRenderFns = []

export { render, staticRenderFns }